<template>
<div class="md-layout">
    <div class="md-layout-item">
        <md-card>
            <header-table titlePage="GASTOS DE MOTORISTAS" :data="tableData" :dadosRel="dadosRel" 
            :columnsPDF="columnsPDF" :headRowsPDF="headRowsPDF" :fildsTXT="fildsTXT" :columnsExcel="columnsExcel" 
            :bodyRowsPDF="bodyRowsPDF" colSpanPDF="4" :totalPDF="total" :titleReport="titleReport" :totalHide="true">
                <md-button class="md-button md-site md-just-icon md-round" :to="{ name: 'Dashboard' }">
                    <i class="fas fa-arrow-left"></i>
                    <md-tooltip md-direction="top">Voltar</md-tooltip>
                </md-button>
            </header-table>
            
            <md-card-content>
                <md-table :value="queriedData" class="paginated-table table-hover table-striped">
                    <md-table-toolbar>
                        <div class="md-layout">
                            <div class="md-layout-item md-size-10 md-xsmall-size-100">
                                <md-field>
                                    <label for="pages">Listar</label>
                                    <md-select v-model="pagination.perPage" name="pages">
                                        <md-option v-for="item in pagination.perPageOptions" :key="item" :label="item" :value="item">
                                            {{ item }}
                                        </md-option>
                                    </md-select>
                                </md-field>
                            </div>

                           <div class="md-layout-item md-size-20 md-xsmall-size-100">
                                <md-datepicker v-model="buscar.dataInicial" md-immediately v-mask="'##/##/####'">
                                    <label>Data Inicial</label>
                                </md-datepicker>
                            </div>

                            <div class="md-layout-item md-size-20 md-xsmall-size-100">
                                <md-datepicker v-model="buscar.dataFinal" md-immediately v-mask="'##/##/####'">
                                    <label>Data Final</label>
                                </md-datepicker>
                            </div>
                            <div class="md-layout-item md-size-10 md-xsmall-size-100">
                                <md-button @click="read()" class="md-site md-round md-block text-right md-sm" style="margin-top:5px">
                                    <md-icon>search</md-icon> BUSCAR
                                </md-button>
                            </div>
                            <div class="md-layout-item md-size-40 md-xsmall-size-100">
                                <md-field md-clearable class="md-toolbar-section-end">
                                    <md-input placeholder="Pesquise no resultado aqui..." v-model="search" @input="searchOnTable" />
                                </md-field>
                            </div>
                        </div>
                    </md-table-toolbar>

                    <md-table-row slot="md-table-row" slot-scope="{ item }" class="tableRow">
                        <md-table-cell md-label="ID" style="width: 10%">{{ item.id }}</md-table-cell>
                        <md-table-cell class="uppercase" md-label="CARRO" style="width: 25%">{{ item.carro }}</md-table-cell>
                        <md-table-cell class="uppercase" md-label="PLACA" style="width: 10%">{{ item.placa }}</md-table-cell>
                        <md-table-cell class="uppercase" md-label="FORNECEDOR" style="width: 35%">{{ item.fornecedor }}</md-table-cell>
                        <md-table-cell v-if="item.id" md-label="DATA" style="width: 10%">{{ item.data_pagamento }}</md-table-cell>                       
                        <md-table-cell v-if="!item.id" md-label="DATA" style="width: 10%"><strong>{{ item.data_pagamento }}</strong></md-table-cell>                       
                        <md-table-cell v-if="item.id" md-label="VALOR" style="width: 10%">{{ item.valor }}</md-table-cell>                       
                        <md-table-cell v-if="!item.id" md-label="VALOR" style="width: 10%"><strong>{{ item.valor }}</strong></md-table-cell>                       
                    </md-table-row>
                </md-table>
            </md-card-content>
            <footer-table :from="from" :to="to" :total="total">
                <pagination class="pagination-site" v-model="pagination.currentPage" :per-page="pagination.perPage" :total="total" />
            </footer-table>
        </md-card>
    </div>
</div>
</template>

<script>
import TableSearch from "@/config/mixins/tableSearch";
import HeaderTable from "@/pages/Layout/Extra/HeaderTable";
import FooterTable from "@/pages/Layout/Extra/FooterTable";
import Notify from '@/config/mixins/notify'
import getDateFormat from '@/config/mixins/getDateFormat';
import {
    Pagination
} from "@/components";
import preLoader from '@/config/mixins/preLoader';

export default {
    name: 'PlanoRead',
    components: {
        HeaderTable,
        FooterTable,
        Pagination
    },

    data() {
        return {
            dados: {
                situacao_id: 1
            },
            permissoes: this.$store.state.usuario.permissao,           
            titleReport: '',
            columnsPDF: [15, 40, 20, 55, 25, 25],
            headRowsPDF: ['ID', 'CARRO', 'PLACA', 'FORNECEDOR', 'DATA', 'VALOR'],
            bodyRowsPDF: ['id', 'carro', 'placa', 'fornecedor', 'data_pagamento', 'valor'],
            fildsTXT: ['id', 'carro', 'placa', 'fornecedor', 'data_pagamento', 'valor_txt'],
            columnsExcel: [

                {
                    label: "ID",
                    field: "id"
                },
                {
                    label: "CARRO",
                    field: "carro",
                    dataFormat: this.upperCaseFormat
                },
                {
                    label: "PLACA",
                    field: "placa",
                    dataFormat: this.upperCaseFormat
                },
                {
                    label: "FORNECEDOR",
                    field: "fornecedor",
                    dataFormat: this.upperCaseFormat
                },
                {
                    label: "DATA",
                    field: "data_pagamento"
                },
                {
                    label: "VALOR",
                    field: "valor_bd"
                }
            ],
            search: null,
            tableData: [],
            searchedData: [],
            dadosRel: [],
            buscar: {
                busca: ''
            }
        };
    },

    mixins: [TableSearch, Notify, preLoader, getDateFormat],

    methods: {
        upperCaseFormat(value) {
            return value.toString().toUpperCase();
        },

        read() {           
            this.titleReport = 'Relatório de gastos - Período ' 
            + this.getDataInicial(this.buscar.dataInicial) + ' a ' + this.getDataFinal(this.buscar.dataFinal)
            let loader = this.openLoader('dots');
            this.$http.post(this.$urlAPI + 'motoristas/gastos', this.buscar)
                .then(response => {
                    if (response.data.status) {
                        this.tableData = response.data.dados
                        this.dadosRel = response.data.lista
                        this.searchOnTable()
                    } else {
                        this.danger(response.data.message)
                    }
                })
                .catch(e => {
                    this.msgErrors(e)
                })
                .finally(function () {
                    loader.hide();
                });
        },

        searchByName(items, term) {
            if (term) {
                return items.filter(item => this.toLower([item.nome, item.cpf, item.empresa]).includes(this.toLower(term)))
            }
            return items
        },
    },

};
</script>
<style>
.md-layout-item {
    margin-top: 5px;
}
</style>
